module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGa705bbc51f7b3ba77d6dbb196e243673.a705bbc5.png";